var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"mx-auto",attrs:{"max-width":"600","loading":_vm.loading}},[_c('v-system-bar',[_vm._v("Dokumente Kategorie: "+_vm._s(_vm.name))]),_c('v-list',_vm._l((_vm.items),function(item){return _c('DocumentItem',{key:item.id,attrs:{"value":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }